import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Main from '../views/Main.vue'

Vue.use(VueRouter, VueAwesomeSwiper)

const routes = [{
        path: '/',
        redirect: '/main'
    },

    {
        path: '/downloadaccel',
        name: 'downloadaccel',
        component: () =>
            import ('../views/pages/DownloadAccel.vue')
    }, 

    {
        path: '/main',
        component: Main,
        children: [{
                path: '',
                name: 'index',
                component: () =>
                    import ('../views/pages/Index.vue')
            },
            {
                path: 'SDWAN',
                name: 'SDWAN',
                component: () =>
                    import ('../views/pages/product/SDWAN.vue')
            },
            {
                path: 'publicize',
                name: 'publicize',
                component: () =>
                    import ('../views/pages/publicize.vue')
            },
            {
                path: 'humanity',
                name: 'humanity',
                component: () =>
                    import ('../views/pages/humanity.vue')
            }, 
            {
                path: 'honor',
                name: 'honor',
                component: () =>
                    import ('../views/pages/honor.vue')
            },
            {
                path: 'news',
                name: 'news',
                component: () =>
                    import ('../views/pages/news.vue')
            },        
            {
                path: 'routeDev',
                name: 'routeDev',
                component: () =>
                    import ('../views/pages/product/RouteDev.vue')
            },
            {
                path: 'fusionGateway',
                name: 'fusionGateway',
                component: () =>
                    import ('../views/pages/product/FusionGateway.vue')
            },
            {
                path: 'smartTV',
                name: 'smartTV',
                component: () =>
                    import ('../views/pages/product/SmartTV.vue')
            },
            {
                path: 'smartScreen',
                name: 'smartScreen',
                component: () =>
                    import ('../views/pages/product/SmartScreen.vue')
            },
            {
                path: 'fusionGateway2',
                name: 'fusionGateway2',
                component: () =>
                    import ('../views/pages/product/fusionGateway2.vue')
            },
            {
                path: 'logAudit',
                name: 'logAudit',
                component: () =>
                    import ('../views/pages/product/LogAudit.vue')
            },
            {
                path: 'SDWAN-Client',
                name: 'SDWAN-Client',
                component: () =>
                    import ('../views/pages/product/SDWAN-Client.vue')
            },
            {
                path: 'JoinUs',
                name: 'JoinUs',
                component: () =>
                    import('../views/pages/product/JoinUs.vue')
            },
            {
                path: 'cooperative',
                name: 'cooperative',
                component: () =>
                    import ('../views/pages/Cooperative.vue')
            },
            {
                path: 'service',
                name: 'service',
                component: () =>
                    import ('../views/pages/Service.vue')
            },
            {
                path: 'download',
                name: 'download',
                component: () =>
                    import ('../views/pages/Download.vue')
            },
            {
                path: 'downloadaccel',
                name: 'downloadaccel',
                component: () =>
                    import ('../views/pages/DownloadAccel.vue')
            },

            {
                path: 'aboutUS',
                name: 'aboutUS',
                component: () =>
                    import ('../views/pages/AboutUS.vue')
            }
        ]
    },
    {
        path: '*',
        name: '404',
        component: () =>
            import ('../views/404.vue')
    }

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(){
        if(!document.getElementById('main_body')){
            return false;
        }
        document.getElementById('main_body').scrollTop = 0;
    }
})

export default router

// 路由守卫